import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-navy text-white p-12 dot-grid">
        <Link to="/" className="flex items-center gap-2 font-heading font-extrabold text-xl">
          <span className="w-9 h-9 rounded-xl bg-teal flex items-center justify-center"><Zap className="w-5 h-5" /></span>
          Beli<span className="text-teal"> Motor Listrik</span>
        </Link>
        <div>
          <h2 className="font-heading font-extrabold text-4xl leading-tight mb-4">Cek dulu, cocok atau tidak.</h2>
          <p className="text-white/70 text-lg">Hitung penghematan, periksa kekuatan tanjakan, dan bandingkan kendaraan berdasarkan kebutuhan Anda.</p>
        </div>
        <p className="text-white/40 text-sm">Hasil merupakan estimasi, bukan jaminan performa.</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 bg-background">
        <div className="w-full max-w-md">
          <Link to="/" className="lg:hidden flex items-center gap-2 font-heading font-extrabold text-navy text-lg mb-8">
            <span className="w-8 h-8 rounded-lg bg-teal flex items-center justify-center text-white"><Zap className="w-4 h-4" /></span>
            Beli Motor Listrik
          </Link>
          <h1 className="font-heading font-extrabold text-3xl text-navy mb-2">{title}</h1>
          {subtitle && <p className="text-muted-foreground mb-6">{subtitle}</p>}
          {children}
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function GoogleButton({ label = "Lanjut dengan Google" }) {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <button
      type="button"
      data-testid="google-login-btn"
      onClick={handleGoogle}
      className="w-full flex items-center justify-center gap-3 h-12 rounded-full border border-border bg-white font-semibold text-navy hover:bg-secondary transition-colors"
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
      {label}
    </button>
  );
}
